/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('WebSiteValidateAccountCtrl', ["$log", "$scope", "$rootScope", "$routeParams", "Auth", "CustomerSrv", "CustomerView", "CustomerData", "BookingView", "BookingData", "DaySrv", "WebPreLoaderData",
    function ($log, $scope, $rootScope, $routeParams, Auth, CustomerSrv, CustomerView, CustomerData, BookingView, BookingData, DaySrv, WebPreLoaderData) {

        $scope.$watch('ad.view.loaded', function (newValue, oldValue) {
            if (newValue) {
                if ($routeParams.token && $routeParams.email)//received change pwd request
                {
                    Auth.loginToWebSiteByToken($routeParams.email, WebPreLoaderData.companyCode, $routeParams.token);
                    CustomerSrv.getByEmail($routeParams.email, function (customer) {
                        customer.isVerified = true;
                        if (!$scope.ad.view.customerView)
                            $scope.ad.view.customerView = new CustomerView(customer, CustomerData.getIndexOf(customer), $scope);
                        else
                            $scope.ad.view.customerView.isVerified = true;
                        $scope.ad.customerConnected = true;
                        CustomerSrv.saveAccount(customer, $scope.onAccountValidated);
                    }, function () { //error
                        //remove cookie and login Anonymous
                        console.log("login official error");
                        Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                    })
                }
            }
        });

        $scope.onAccountValidated = function () {
            CustomerSrv.getBookings($scope.ad.view.customerView.getModel(), function (bookings) {
                var bookingView;
                console.log(bookings);
                if (bookings) {
                    $scope.ad.view.customerView.pastBookingsView = [];
                    $scope.ad.view.customerView.futureBookingsView = [];

                    for (var i = 0; i < bookings.length; i++) {
                        bookingView = new BookingView(bookings[i], BookingData.getIndexOf(bookings[i]), $scope);
                        bookingView.date = DaySrv.getDateFromId(bookings[i].day.id);
                        $scope.ad.view.customerView.addBookingView(bookingView);
                    }
                    console.log($scope.ad.view.customerView);
                }
            })
        }

    }]);



// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteValidateAccountCtrl.js